import "bunja";

//#region hook.ts
function getHook() {
	return globalThis.__BUNJA_DEVTOOLS_GLOBAL_HOOK__;
}

//#endregion
export { getHook };